export interface BodyRegion {
  id: string;
  label: string;
  keywords: string[];
}

export const BODY_REGIONS: BodyRegion[] = [
  {
    id: 'head-brain',
    label: 'Head & Brain',
    keywords: [
      'head', 'brain', 'cerebral', 'cranial', 'skull', 'concussion', 'headache', 'migraine',
      'meningitis', 'encephalitis', 'stroke', 'cerebrovascular', 'intracranial', 'traumatic brain',
      'subdural', 'epidural', 'hematoma', 'seizure', 'epilepsy', 'neurology', 'cognitive',
      'dementia', 'alzheimer', 'parkinson', 'tremor', 'scalp'
    ],
  },
  {
    id: 'eyes',
    label: 'Eyes',
    keywords: [
      'eye', 'ocular', 'optic', 'retina', 'vision', 'cataract', 'glaucoma', 'macular',
      'conjunctivitis', 'ophthalmology', 'orbital', 'pupil', 'cornea', 'lens', 'blind',
      'visual acuity', 'periorbital'
    ],
  },
  {
    id: 'neck-throat',
    label: 'Neck & Throat',
    keywords: [
      'neck', 'throat', 'cervical', 'thyroid', 'larynx', 'pharynx', 'tonsil', 'swallow',
      'dysphagia', 'hoarse', 'trachea', 'oesophagus', 'esophagus', 'lymph node', 'goitre',
      'goiter', 'carotid', 'strep', 'sore throat'
    ],
  },
  {
    id: 'chest-lungs',
    label: 'Chest & Lungs',
    keywords: [
      'chest', 'lung', 'pulmonary', 'respiratory', 'pneumonia', 'asthma', 'copd', 'bronchitis',
      'pleural', 'thorax', 'thoracic', 'cough', 'dyspnoea', 'dyspnea', 'breathless', 'wheeze',
      'inhaler', 'bronchodilator', 'nebuliser', 'nebulizer', 'sputum', 'tuberculosis', 'tb',
      'chest x-ray', 'rib', 'sternum', 'diaphragm', 'pleurisy', 'emphysema', 'oxygen saturation',
      'spo2', 'apnoea', 'apnea'
    ],
  },
  {
    id: 'heart-cardiovascular',
    label: 'Heart & Cardiovascular',
    keywords: [
      'heart', 'cardiac', 'cardiovascular', 'coronary', 'myocardial', 'infarction', 'angina',
      'arrhythmia', 'atrial', 'fibrillation', 'palpitation', 'ecg', 'ekg', 'echocardiogram',
      'blood pressure', 'hypertension', 'hypotension', 'tachycardia', 'bradycardia', 'aorta',
      'valve', 'stent', 'bypass', 'angioplasty', 'troponin', 'heart failure', 'murmur',
      'pericarditis', 'endocarditis', 'dvt', 'embolism', 'thrombosis', 'anticoagulant',
      'warfarin', 'heparin'
    ],
  },
  {
    id: 'abdomen-gi',
    label: 'Abdomen & GI',
    keywords: [
      'abdomen', 'abdominal', 'stomach', 'gastric', 'bowel', 'intestin', 'colon', 'liver',
      'hepatic', 'gallbladder', 'pancreas', 'pancreatic', 'spleen', 'appendix', 'hernia',
      'nausea', 'vomit', 'diarrhoea', 'diarrhea', 'constipation', 'crohn', 'colitis',
      'ibs', 'reflux', 'gerd', 'ulcer', 'gastroenteritis', 'cirrhosis', 'jaundice',
      'bilirubin', 'endoscopy', 'colonoscopy', 'stool', 'faecal', 'fecal', 'rectal',
      'haemorrhoid', 'hemorrhoid', 'peritonitis', 'obstruction'
    ],
  },
  {
    id: 'pelvis-urogenital',
    label: 'Pelvis & Urogenital',
    keywords: [
      'pelvis', 'pelvic', 'kidney', 'renal', 'bladder', 'urinary', 'urine', 'prostate',
      'uterus', 'uterine', 'ovary', 'ovarian', 'cervical cancer', 'testicul', 'genital',
      'catheter', 'uti', 'cystitis', 'nephritis', 'dialysis', 'creatinine', 'urea',
      'incontinence', 'gynaecolog', 'gynecolog', 'menstr', 'pregnancy', 'obstetric',
      'miscarriage', 'fertility', 'erectile'
    ],
  },
  {
    id: 'spine-back',
    label: 'Spine & Back',
    keywords: [
      'spine', 'spinal', 'back pain', 'lumbar', 'thoracic spine', 'cervical spine', 'disc',
      'vertebra', 'sciatica', 'scoliosis', 'kyphosis', 'lordosis', 'laminectomy', 'spinal cord',
      'paraplegia', 'quadriplegia', 'sacrum', 'sacral', 'coccyx', 'epidural injection',
      'degenerative disc', 'stenosis'
    ],
  },
  {
    id: 'upper-limbs',
    label: 'Upper Limbs',
    keywords: [
      'arm', 'shoulder', 'elbow', 'wrist', 'hand', 'finger', 'thumb', 'humerus', 'radius',
      'ulna', 'carpal', 'rotator cuff', 'frozen shoulder', 'tennis elbow', 'trigger finger',
      'fracture arm', 'fracture wrist', 'dislocation shoulder', 'amputation hand',
      'upper extremity', 'forearm', 'bicep', 'grip strength'
    ],
  },
  {
    id: 'lower-limbs',
    label: 'Lower Limbs',
    keywords: [
      'leg', 'hip', 'knee', 'ankle', 'foot', 'toe', 'femur', 'tibia', 'fibula', 'patella',
      'meniscus', 'acl', 'ligament', 'hip replacement', 'knee replacement', 'arthroplasty',
      'fracture hip', 'fracture femur', 'amputation leg', 'gait', 'mobility', 'walking',
      'lower extremity', 'thigh', 'calf', 'plantar', 'bunion', 'achilles', 'shin'
    ],
  },
  {
    id: 'skin',
    label: 'Skin',
    keywords: [
      'skin', 'dermatology', 'rash', 'eczema', 'psoriasis', 'wound', 'ulcer skin', 'pressure sore',
      'decubitus', 'laceration', 'abrasion', 'burn', 'bruise', 'contusion', 'cellulitis',
      'abscess', 'melanoma', 'mole', 'dermatitis', 'hives', 'urticaria', 'pruritus', 'itch',
      'blister', 'scab', 'scar', 'tissue viability', 'pressure ulcer', 'grade 2', 'grade 3',
      'grade 4', 'necrotic'
    ],
  },
  {
    id: 'systemic',
    label: 'Systemic / Whole Body',
    keywords: [
      'systemic', 'sepsis', 'infection', 'fever', 'temperature', 'pyrexia', 'diabetes',
      'diabetic', 'insulin', 'glucose', 'hba1c', 'anaemia', 'anemia', 'haemoglobin',
      'hemoglobin', 'cancer', 'malignant', 'metastasis', 'chemotherapy', 'radiotherapy',
      'immune', 'autoimmune', 'lupus', 'rheumatoid', 'arthritis', 'osteoporosis',
      'obesity', 'bmi', 'nutrition', 'dehydration', 'electrolyte', 'sodium', 'potassium',
      'fatigue', 'weight loss', 'weight gain', 'pain management', 'palliative', 'end of life',
      'morphine', 'opioid', 'antibiotic', 'paracetamol', 'ibuprofen'
    ],
  },
  {
    id: 'mental-health',
    label: 'Mental Health',
    keywords: [
      'mental health', 'psychiatric', 'psychology', 'depression', 'anxiety', 'ptsd',
      'schizophrenia', 'bipolar', 'psychosis', 'hallucination', 'delusion', 'suicidal',
      'self-harm', 'eating disorder', 'anorexia', 'bulimia', 'ocd', 'adhd', 'autism',
      'personality disorder', 'mood', 'antidepressant', 'ssri', 'benzodiazepine',
      'cognitive behavioural', 'counselling', 'therapy', 'sectioned', 'mental capacity',
      'capacity assessment', 'confusion', 'agitation', 'delirium', 'insomnia', 'sleep'
    ],
  },
];

export interface TermCitation {
  documentId: string;
  pageNumber?: number;
  chunkIndex?: number;
  text: string;
  relevanceScore?: number;
}

export interface MappedTerm {
  term: string;
  category: string;
  frequency: number;
  confidence: number;
  citations?: TermCitation[];
}

export interface MappedKeyDate {
  date: string;
  type: string;
  context: string;
  headline?: string;
  confidence: number;
  citations?: TermCitation[];
}

/**
 * Maps key dates to body regions using the same keyword matching as terms.
 */
export function mapDatesToRegions(
  keyDates: { date: string; type: string; context: string; headline?: string; confidence: number; citations?: TermCitation[] }[]
): Map<string, MappedKeyDate[]> {
  const regionMap = new Map<string, MappedKeyDate[]>();
  BODY_REGIONS.forEach(region => regionMap.set(region.id, []));

  keyDates.forEach(kd => {
    const contextLower = (kd.context || '').toLowerCase();
    const typeLower = (kd.type || '').toLowerCase();

    for (const region of BODY_REGIONS) {
      for (const keyword of region.keywords) {
        if (contextLower.includes(keyword) || typeLower.includes(keyword)) {
          const existing = regionMap.get(region.id)!;
          existing.push({
            date: kd.date,
            type: kd.type,
            context: kd.context,
            headline: kd.headline,
            confidence: kd.confidence,
            citations: kd.citations,
          });
          break;
        }
      }
    }
  });

  return regionMap;
}

export function mapTermsToRegions(terms: MappedTerm[]): Map<string, MappedTerm[]> {
  const regionMap = new Map<string, MappedTerm[]>();

  // Initialize all regions
  BODY_REGIONS.forEach(region => {
    regionMap.set(region.id, []);
  });

  const unmapped: MappedTerm[] = [];

  terms.forEach(term => {
    const termLower = term.term.toLowerCase();
    const categoryLower = term.category.toLowerCase();
    let matched = false;

    for (const region of BODY_REGIONS) {
      for (const keyword of region.keywords) {
        if (termLower.includes(keyword) || categoryLower.includes(keyword)) {
          const existing = regionMap.get(region.id)!;
          // Avoid duplicates
          if (!existing.some(t => t.term === term.term)) {
            existing.push(term);
          }
          matched = true;
          break;
        }
      }
    }

    if (!matched) {
      unmapped.push(term);
    }
  });

  // Add unmapped as special key
  regionMap.set('unmapped', unmapped);

  return regionMap;
}

// ---------------------------------------------------------------------------
// Aggregation layer — groups related terms for a simplified overview
// ---------------------------------------------------------------------------

/** Grouping stems: if a term contains the stem, it gets grouped under the label. */
const GROUPING_STEMS: { stem: string; label: string }[] = [
  { stem: 'fracture', label: 'Fractures' },
  { stem: 'dislocation', label: 'Dislocations' },
  { stem: 'strain', label: 'Strains' },
  { stem: 'sprain', label: 'Sprains' },
  { stem: 'contusion', label: 'Contusions' },
  { stem: 'laceration', label: 'Lacerations' },
  { stem: 'haematoma', label: 'Haematomas' },
  { stem: 'hematoma', label: 'Haematomas' },
  { stem: 'effusion', label: 'Effusions' },
  { stem: 'stenosis', label: 'Stenosis' },
  { stem: 'tenderness', label: 'Tenderness' },
  { stem: 'pain', label: 'Pain' },
  { stem: 'swelling', label: 'Swelling' },
  { stem: 'numbness', label: 'Numbness / paraesthesia' },
  { stem: 'paraesthesia', label: 'Numbness / paraesthesia' },
  { stem: 'paresthesia', label: 'Numbness / paraesthesia' },
  { stem: 'weakness', label: 'Weakness' },
  { stem: 'immobilisation', label: 'Immobilisation' },
  { stem: 'immobilization', label: 'Immobilisation' },
  { stem: 'replacement', label: 'Joint replacements' },
  { stem: 'arthroplasty', label: 'Joint replacements' },
  { stem: 'degenerat', label: 'Degenerative changes' },
  { stem: 'osteoarthr', label: 'Degenerative changes' },
  { stem: 'infection', label: 'Infections' },
  { stem: 'abscess', label: 'Infections' },
  { stem: 'cellulitis', label: 'Infections' },
  { stem: 'oedema', label: 'Oedema' },
  { stem: 'edema', label: 'Oedema' },
  { stem: 'imaging', label: 'Imaging' },
  { stem: 'x-ray', label: 'Imaging' },
  { stem: 'mri', label: 'Imaging' },
  { stem: 'ct scan', label: 'Imaging' },
  { stem: 'radiograph', label: 'Imaging' },
  { stem: 'ultrasound', label: 'Imaging' },
  { stem: 'wound', label: 'Wounds' },
  { stem: 'ulcer', label: 'Ulcers' },
  { stem: 'bruising', label: 'Bruising' },
  { stem: 'bruise', label: 'Bruising' },
  { stem: 'scar', label: 'Scarring' },
];

export interface AggregatedFinding {
  label: string;
  category: string;
  terms: MappedTerm[];
  citations: TermCitation[];
}

/** Category tiers for display priority */
export const TIER1_CATEGORIES = ['DIAGNOSIS', 'CONDITION'];
export const TIER2_CATEGORIES = ['PROCEDURE', 'SYMPTOM'];
// Everything else is Tier 3

export function getTier(category: string): 1 | 2 | 3 {
  const upper = (category || '').toUpperCase();
  if (TIER1_CATEGORIES.includes(upper)) return 1;
  if (TIER2_CATEGORIES.includes(upper)) return 2;
  return 3;
}

/**
 * Aggregates a list of mapped terms into grouped findings.
 * Terms sharing the same grouping stem AND category are merged.
 * Terms matching no stem remain as singletons.
 */
export function aggregateRegionTerms(terms: MappedTerm[]): AggregatedFinding[] {
  // key = `${groupLabel}::${category}`, value = terms in that group
  const groups = new Map<string, { label: string; category: string; terms: MappedTerm[] }>();
  const singletons: MappedTerm[] = [];

  for (const term of terms) {
    const termLower = term.term.toLowerCase();
    let matched = false;

    for (const { stem, label } of GROUPING_STEMS) {
      if (termLower.includes(stem)) {
        const key = `${label}::${term.category.toUpperCase()}`;
        const existing = groups.get(key);
        if (existing) {
          existing.terms.push(term);
        } else {
          groups.set(key, { label, category: term.category, terms: [term] });
        }
        matched = true;
        break;
      }
    }

    if (!matched) {
      singletons.push(term);
    }
  }

  const results: AggregatedFinding[] = [];

  // Convert groups to AggregatedFinding
  for (const group of groups.values()) {
    const citations = deduplicateCitations(
      group.terms.flatMap(t => t.citations || [])
    );
    results.push({
      label: group.terms.length > 1
        ? `${group.label} (${group.terms.length})`
        : group.terms[0].term,
      category: group.category,
      terms: group.terms,
      citations,
    });
  }

  // Singletons become their own AggregatedFinding
  for (const term of singletons) {
    results.push({
      label: term.term,
      category: term.category,
      terms: [term],
      citations: term.citations ? [...term.citations] : [],
    });
  }

  // Sort: Tier 1 first, then Tier 2, then Tier 3. Within each tier, by term count desc.
  results.sort((a, b) => {
    const tierDiff = getTier(a.category) - getTier(b.category);
    if (tierDiff !== 0) return tierDiff;
    return b.terms.length - a.terms.length;
  });

  return results;
}

function deduplicateCitations(citations: TermCitation[]): TermCitation[] {
  const seen = new Set<string>();
  const result: TermCitation[] = [];
  for (const c of citations) {
    const key = `${c.documentId}:${c.pageNumber ?? ''}:${c.chunkIndex ?? ''}`;
    if (!seen.has(key)) {
      seen.add(key);
      result.push(c);
    }
  }
  return result;
}

/**
 * Builds a plain-English narrative sentence from aggregated findings.
 * Focuses on Tier 1 (diagnoses/conditions) and Tier 2 (procedures/symptoms).
 */
export function buildRegionNarrative(findings: AggregatedFinding[]): string {
  const tier1 = findings.filter(f => getTier(f.category) === 1);
  const tier2Procedures = findings.filter(
    f => f.category.toUpperCase() === 'PROCEDURE'
  );
  const tier2Symptoms = findings.filter(
    f => f.category.toUpperCase() === 'SYMPTOM'
  );

  const parts: string[] = [];

  if (tier1.length > 0) {
    const labels = tier1.slice(0, 4).map(f => f.label.toLowerCase());
    parts.push(`Key findings: ${formatList(labels)}`);
  }

  if (tier2Procedures.length > 0) {
    const labels = tier2Procedures.slice(0, 3).map(f => f.label.toLowerCase());
    parts.push(`Treatment included ${formatList(labels)}`);
  }

  if (tier2Symptoms.length > 0 && tier1.length === 0) {
    // Only show symptoms if no diagnoses (otherwise it's noise)
    const labels = tier2Symptoms.slice(0, 3).map(f => f.label.toLowerCase());
    parts.push(`Reported symptoms: ${formatList(labels)}`);
  }

  if (parts.length === 0) {
    const labels = findings.slice(0, 3).map(f => f.label.toLowerCase());
    return `Findings include ${formatList(labels)}.`;
  }

  return parts.join('. ') + '.';
}

function formatList(items: string[]): string {
  if (items.length === 0) return '';
  if (items.length === 1) return items[0];
  if (items.length === 2) return `${items[0]} and ${items[1]}`;
  return `${items.slice(0, -1).join(', ')}, and ${items[items.length - 1]}`;
}
